import * as types from "../constants/actionTypes";
import * as tools from "../helpers/Tools";

export const localCacheInitialState = {
};

export default function localCacheReducer(state = localCacheInitialState, action) {
    switch (action.type) {
        default:
            return { ...state };
    }
};
